import { CompensationMethod } from "../../../compensation-method";

/**
 * Metadata keys used to record that a Brightpearl customer-payment has been
 * POSTed against a sales credit for a given compensation leg. Per-leg keys let
 * `markSalesCreditAsPaid` short-circuit individual legs on retry without
 * round-tripping BP — keying by the BP-side `transactionRef` would still work
 * via BP's uniqueness check, but local dedupe keeps the retry from issuing
 * the POST in the first place.
 */
export const BRIGHTPEARL_CUSTOMER_PAYMENT_METADATA_KEYS: Record<
  CompensationMethod,
  string
> = {
  [CompensationMethod.REFUND]: "brightpearl-customer-payment-refund",
  [CompensationMethod.EXCHANGE]: "brightpearl-customer-payment-exchange",
  [CompensationMethod.STORE_CREDIT]:
    "brightpearl-customer-payment-store-credit",
};

/** Which return actions void the Brightpearl sales credit Redo pushed. */
export enum BrightpearlCancelSalesCreditOn {
  NEVER = "never",
  RESET = "reset",
  REJECT = "reject",
  BOTH = "both",
}

/** Unset means both: a credit outliving its return is never wanted. */
export function shouldCancelSalesCreditOn(
  action: "reject" | "reset",
  setting: BrightpearlCancelSalesCreditOn | undefined,
): boolean {
  switch (setting ?? BrightpearlCancelSalesCreditOn.BOTH) {
    case BrightpearlCancelSalesCreditOn.NEVER:
      return false;
    case BrightpearlCancelSalesCreditOn.BOTH:
      return true;
    case BrightpearlCancelSalesCreditOn.RESET:
      return action === "reset";
    case BrightpearlCancelSalesCreditOn.REJECT:
      return action === "reject";
  }
}
